<template>
    <v-content>
        <v-row class="pb-0 pb-sm-10">
            <v-col class="display-1">
                {{ action === "update" ? "Редактирование шаблона" : "Создание шаблона" }}
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="info" depressed @click="back()">
                        Назад
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Название:</p>
                    <v-text-field
                        outlined
                        label="Название"
                        v-model="notification_template.name"
                    ></v-text-field>
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                  <p class="text-field-header">Тип шаблона:</p>
                  <v-select
                    v-model="notification_template.type"
                    :items="types"
                    item-text="name"
                    item-value="value"
                    label="Тип шаблона"
                    outlined
                    hide-details
                    clearable
                    @change="changeType"
                    dense
                    :disabled="action === 'update'"
                  />
                </div>
            </v-col>
            <v-col>
                <b-button class="is-pulled-right"
                          type="is-primary"
                          :disabled="action === 'update'"
                          icon-right="plus" @click="add()">
                    Добавить этап
                </b-button>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <div v-if="notification_template.type === 'sms' && notification_template.linked_notifications_info" v-for="(sms, index) in notification_template.linked_notifications_info" :key="'key_' + index">
            <div class="notification-row is-vcentered">
                <div class="column">
                    <div class="columns">
                        <div class="column is-2">
                            <b-field label="Название">
                                <b-input v-model="sms.name"
                                    :disabled="action === 'update'"
                                ></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-6">
                            <b-field label="Ссылка">
                                <b-input type="textarea" v-model="sms.url"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-6">
                            <b-field expanded label="Шаблон СМС">
                                <b-input expanded maxlength="200" type="textarea" v-model="sms.text_template"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-2">
                            <b-field label="Тип канала?">
                                <b-select placeholder="" icon="duck" v-model="sms.channel">
                                    <option
                                            v-for="channel in channels"
                                            :value="channel.id"
                                            :key="channel.id">
                                        {{ channel.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-2" v-if="sms.channel === 'char'">
                            <b-field label="Имя отправителя">
                                <b-select placeholder="" icon="duck" v-model="sms.sender" @input="changeSenDom(sms, 'sender')">
                                    <option
                                            v-for="sender in senders"
                                            :value="sender"
                                            :key="sender">
                                        {{ sender}}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Домен">
                                <b-select placeholder="" icon="duck" v-model="sms.domain" @input="changeSenDom(sms, 'domain')">
                                    <option
                                            v-for="domain in domains"
                                            :value="domain"
                                            :key="domain">
                                        {{ domain }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Аккаунт">
                                <b-select
                                    placeholder="Выбери аккаунт"
                                    expanded
                                    v-model="sms.account_mailer.id"
                                >
                                    <option
                                        v-for="acc in mailing_accounts.filter(t => t.type_of_notification === 'sms')"
                                        :key="acc.id"
                                        :value="acc.id"
                                    >
                                        {{ acc.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Соотношение">
                                <b-input v-model="sms.percent"
                                    :disabled="action === 'update'"
                                ></b-input>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Удалить">
                                <b-button class="button is-danger" icon-right="trash-can" @click="remove(index)">
                                </b-button>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="notification_template.type === 'call' && notification_template.linked_notifications_info" v-for="(call, index) in notification_template.linked_notifications_info" :key="'key_' + index">
            <div class="notification-row is-vcentered">
                <div class="column">
                    <div class="columns">
                        <div class="column is-2">
                            <b-field label="Название">
                                <b-input v-model="call.name"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                       <div class="column is-2">
                            <b-field label="Использовать дежурный номер?">
                                <b-switch v-model="call.from_duty_phone"></b-switch>
                            </b-field>
                        </div>
                        <div class="column is-3" v-if="!call.from_duty_phone">
                            <b-field expanded label="Номер телефона">
                                <b-select
                                  placeholder="Номер телефона"
                                  icon="duck"
                                  v-model="call.outgoing_phone_id"
                                >
                                  <option
                                    v-for="phone in phones"
                                    :value="phone.id"
                                    :key="phone.id"
                                  >
                                    {{ phone.phone }}
                                  </option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Шаблон">
                                <b-select placeholder="" icon="duck" v-model="call.call_template_id">
                                    <option
                                            v-for="template in templates"
                                            :value="template.id"
                                            :key="template.id">
                                        {{ template.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-2">
                            <b-field label="Аккаунт">
                                <b-select
                                    placeholder="Выбери аккаунт"
                                    expanded
                                    v-model="call.account_mailer.id"
                                >
                                    <option
                                        v-for="acc in mailing_accounts.filter(t => t.type_of_notification === 'call')"
                                        :key="acc.id"
                                        :value="acc.id"
                                    >
                                        {{ acc.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Соотношение">
                                <b-input v-model="call.percent"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Удалить">
                                <b-button class="button is-danger" icon-right="trash-can" @click="remove(index)">
                                </b-button>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-divider></v-divider>
        <div class="columns" v-if="notification_template.type === 'sms'">
          <div class="column" v-if="notification_template.type === 'sms'">
            <p>Доступные переменные для текста: </p>
            <p><b>{short_link}</b> - Короткая ссылка</p>
            <p><b>{name}</b> - Имя клиента</p>
            <p>Доступные переменные для ссылки: </p>
            <p><b>{aff_sub1}</b> - Aff_sub1 пользователя</p>
            <p><b>{aff_sub2}</b> - Aff_sub2 пользователя</p>
            <p><b>{aff_sub3}</b> - Aff_sub3 пользователя</p>
            <p><b>{aff_sub4}</b> - Aff_sub4 пользователя</p>
            <p><b>{aff_sub5}</b> - Aff_sub5 пользователя</p>
            <p><b>{phone}</b> - Номер телефона пользователя</p>
            <p><b>{click_uuid}</b> - Click_uuid пользователя</p>
            <p><b>{source}</b> - Source рассылки (для цепочки надо самостоятельно прописывать в ссылке, а в instant будет поле)</p>
            <p><b>{reg_date}</b> - Дата регистрации пользователя</p>
            <p><b>{aff_sub9}</b> - Поставщик рассылок</p>
          </div>
        </div>
        <v-col>
            <div class="float-right">
                <v-btn color="primary" depressed @click="saveTemplate()">
                    <v-icon small>mdi-plus</v-icon>
                    Сохранить
                </v-btn>
            </div>
        </v-col>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import draggable from "vuedraggable";

export default {
    name: "UpdateTemplate",
    components: {
        draggable,
        OverlayLoader,
    },
    created() {
        if (this.action == "update") {
            this.$store.dispatch("GET_TEMPLATE_NOTIFICATION_BY_ID", this.templateId);
        }
        else {
            this.$store.dispatch("RESET_CURRENT_TEMPLATE_NOTIFICATION");
        }
        this.$store.dispatch('GET_OUTGOING_PHONES_LIST');
        this.$store.dispatch('GET_TEMPLATES');
        this.$store.dispatch('GET_SMS_INFO');
        this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', {is_used: true});
    },
    data() {
        return {
            types: [
                { name: "Смс", value: 'sms' },
                { name: "Звонок", value: 'call' },
            ],
            channels: [{id:'char', name: 'Буква'}, {id:'digit', name: 'Цифра'}],
            notification_template_sms : {
                text_template: null,
                url: null,
                name: null,
                domain: null,
                sender: null,
                channel: null,
                percent: null,
                account_mailer: {name: ''},
            },
            notification_template_call: {
                name: null,
                from_duty_phone: null,
                account_mailer: {name: ''},
            },
            template_info_sms: null,
            template_info_call: null,
        };
    },
    computed: {
        templateId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateTemplate" && this.templateId ? "update" : "create";
        },
        notification_template() {
            return this.$store.getters.TEMPLATE_NOTIFICATION;
        },
        isLoading() {
            return this.$store.getters.TEMPLATES_LOADING;
        },
        domains() {
          return this.$store.getters.SMS_DOMAINS;
        },
        senders() {
          return this.$store.getters.SMS_SENDERS;
        },
        templates() {
            return this.$store.getters.TEMPLATES.results;
        },
        phones() {
          return this.$store.getters.PHONES;
        },
        mailing_accounts() {
          return (this.$store.getters.MAILING_ACCOUNTS_LIST.results || []);
        },
    },
    methods: {
        saveTemplate() {
            let sum = this.notification_template.linked_notifications_info.reduce((a, b) => parseFloat(a) + (parseFloat(b['percent']) || 0.0), 0.0);
            if (sum !== 100){
                this.$toaster.error("Сумма процентов не равна 100!");
            }
            else {
                const actions = this.action === 'create' ? 'CREATE_TEMPLATE_NOTIFICATION' : 'UPDATE_TEMPLATE_NOTIFICATION';
                this.$store
                    .dispatch(actions, this.notification_template)
                    .then(() => {
                        this.$toast.success("Шаблон сохранен");
                        this.$router.push({ path: "/templates" });
                    })
                    .catch(() => {
                        this.$toaster.error("Неизвестная ошибка!");
                    });
            }
        },
        back(){
          if(this.isModal) {
            this.isModal = false;
            this.$emit('close');
          } else {
              this.$router.push({path: "/templates"});
          }
        },
        remove(index){
            this.notification_template.linked_notifications_info.splice(index, 1);
        },
        add(){
            this.notification_template.linked_notifications_info.push(this.notification_template.type === 'sms' ? Object.assign({}, this.notification_template_sms) : Object.assign({}, this.notification_template_call));
        },
        changeSenDom(template, event) {
            if (event === 'domain') {
                const value = template.domain;
                if (this.domains.includes(value) && this.senders.includes(value)) {
                    template.sender = value;
                }
            }
            else {
                const value = template.sender;
                if (this.domains.includes(value) && this.senders.includes(value)) {
                    template.domain = value;
                }
            }
        },
        changeType(){
             this.notification_template.linked_notifications_info = [this.notification_template.type === 'sms' ? Object.assign({}, this.notification_template_sms) : Object.assign({}, this.notification_template_call)];
        },
    },
};
</script>

<style>
    .notification-row {
        width: 100%;
        background-color: #fff;
        border: solid 1px #cecece;
        border-radius: 5px;
        padding: 10px;
    }
</style>
